import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

const initialState = {
  isSidebarOpen: true
};

let store = set => ({
  ...initialState,
  toggleSidebar: () => {
    set(state => ({
      isSidebarOpen: !state.isSidebarOpen
    }));
  },
  closeSidebar: () => {
    set({
      isSidebarOpen: false
    });
  },
  reset: () => set(initialState)
});

store = persist(store, {
  name: 'productFilters',
  storage: createJSONStorage(() => sessionStorage)
});
export const useSidebar = create(devtools(store));
